module.exports = __webpack_public_path__ + "15b984dd5eb05f073978ebb8bb3b1320.png";